/**
 * Constants regarding the sessionStorage
 */
export default Object.freeze({
  PREFIX: 'price_indicator',
  FIELDS_HAUS: [
    'kundeNachname',
    'kundeAnrede',
    'kundeVorname',
    'kundeEmail',
    'strasse',
    'plz',
    'ort',
    'hausnr',
    'indexRechtsform',
    'grundFlaeche',
    'hausBaujahr',
    'indexArtGebaeudesanierung',
    'indexHausAusstattung',
    'indexHausWaermedaemmung',
    'hausNutzflaecheM2',
    'indexHausErhaltung',
    'hausKellerM2',
    'f_zweck',
  ],
  FIELDS_WOHNUNG: [
    'kundeAnrede',
    'kundeVorname',
    'kundeNachname',
    'kundeEmail',
    'plz',
    'ort',
    'strasse',
    'hausnr',
    'topnr',
    'whgStockIst',
    'whgStockGesamt',
    'gebaeudeBaujahr',
    'whgNutzflaecheM2',
    'indexRechtsform',
    'indexGebaeudeWaermedaemmung',
    'flagLift',
    'indexWhgErhaltung',
    'indexWhgAusstattung',
    'whgBalkonM2',
    'whgGaragenStk',
    'whgGartenM2',
    'TerrasseM2',
    'f_zweck',
    'heatpump',
    'indexWhgObjektKategorie',
    'indexWhgImmobilienart',
  ],
  FIELDS_DG_WOHNUNG: [
    'kundeAnrede',
    'kundeVorname',
    'kundeNachname',
    'kundeEmail',
    'plz',
    'ort',
    'strasse',
    'hausnr',
    'topnr',
    'whgStockIst',
    'gebaeudeBaujahr',
    'whgNutzflaecheM2',
    'indexRechtsform',
    'indexGebaeudeWaermedaemmung',
    'flagLift',
    'indexWhgErhaltung',
    'indexWhgAusstattung',
    'whgBalkonM2',
    'whgGaragenStk',
    'TerrasseM2',
    'f_zweck',
    'heatpump',
    'indexWhgObjektKategorie',
    'indexWhgImmobilienart',
  ],
  FIELDS_REIHENHAUS: [
    'kundeAnrede',
    'kundeVorname',
    'kundeNachname',
    'kundeEmail',
    'plz',
    'ort',
    'strasse',
    'hausnr',
    'gebaeudeBaujahr',
    'whgNutzflaecheM2',
    'indexRechtsform',
    'indexGebaeudeWaermedaemmung',
    'indexWhgErhaltung',
    'indexWhgAusstattung',
    'whgBalkonM2',
    'whgGaragenStk',
    'whgGartenM2',
    'TerrasseM2',
    'f_zweck',
    'heatpump',
    'indexWhgObjektKategorie',
    'indexWhgImmobilienart',
  ],
  FIELDS_BAUGRUNDSTUECK: [
    'plz',
    'ort',
    'strasse',
    'hausnr',
    'grundFlaeche',
    'davonBauland',
    'kundeAnrede',
    'kundeVorname',
    'kundeNachname',
    'kundeEmail',
    'f_zweck',
  ],
  ID_THEMA_KAUFEN: 'E9D2F293800E3185E053301DC60A5D89',
  ID_THEMA_VERKAUFEN: 'E9D2F29380123185E053301DC60A5D89',
  ID_NL_SBAU: 'B8D83F32EFC03CD4E054020820F0E7BD',
  // for PROD
  API_BASE_URL: 'https://immobilienbewertung.sparkasse.at/calculate/api',
  // for internal use only (FAT)
  // API_BASE_URL: 'https://allnet-services.stable.ibw.microf.cs.eb.lan.at/api',
  NEWSLETTER_URL: 'https://nbca.erstegroup.com/prosoweb/customerregistrations',
  NEW_BUILDING_THRESHOLD: 30,
});
